export const videosViewMixin = (type = 'pre-training') => ({
  props: {
    serie: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    showModal: {
      type: Boolean,
      required: false,
      default: false,
    },
    language: {
      type: Object,
      required: false,
      default: () => ({ code: 'en' }),
    },
  },
  data() {
    return {
      videos: [],
      resources: [],
      videosLoading: false,
    };
  },
  methods: {
    handleEdit(id) {
      const to = {
        'pre-training': `/admin/pre-training/edit/${id}`,
        'post-training-videos': `/admin/post-training-videos/edit/${id}`,
        'training-videos': `/admin/training-videos/edit/${id}`,
      };
      this.$router.push(to[type]);
    },
    async handleDelete(videoId) {
      const endpoints = {
        'pre-training': `/admin/pre-training/${videoId}`,
        'post-training-videos': `/admin/post-training-videos/${videoId}`,
        'training-videos': `/admin/training-videos/${videoId}`,
      };
      await this.$http.delete(endpoints[type]);
      this.videos = this.videos.filter(video => video.id !== videoId);
    },
    handleClose() {
      this.$emit('close');
      // ensure to reset form data before closing modal
      this.handleResetFields();
      this.handleResetErrors();
    },
    async fetchVideos(http, group_id, lang_code) {
      const endpoints = {
        'pre-training': '/admin/pre-training',
        'post-training-videos': '/admin/post-training-videos',
        'training-videos': '/admin/training-videos',
      };

      const { data } = await http.get(endpoints[type], {
        params: { group_id, lang_code },
      });

      return data.data;
    },
  },
  async mounted() {
    this.videosLoading = true;
    this.videos = await this.fetchVideos(this.$http, this.$route.params.id, this.language.code);
    this.videosLoading = false;
  },
});
